module.exports = __webpack_public_path__ + "static/media/Large_2019.b7bf4266.svg";